import * as yup from 'yup'

import {
  EMAIL_PATTERN,
  NPI_NUMBER_PATTERN,
  PHONE_NUMBER_PATTERN,
  SSN_NUMBER_PATTERN,
  ZIP_CODE_PATTERN,
} from '../constants/Patterns'
import { INVERSE_SEQUENCE, PIN_LENGTH, SEQUENCE } from '../constants/Pin'

export const emailValidator = yup.string().matches(EMAIL_PATTERN, {
  excludeEmptyString: true,
  message: 'isValidEmail',
})

export const npiNumberValidator = yup.string().matches(NPI_NUMBER_PATTERN, {
  excludeEmptyString: true,
  message: 'isValidNPI',
})

export const phoneNumberValidator = yup
  .string()
  .matches(PHONE_NUMBER_PATTERN, {
    excludeEmptyString: true,
    message: 'isValidPhone',
  })
  .nullable(true)
  .notRequired()

export const ssnNumberValidator = yup.string().matches(SSN_NUMBER_PATTERN, {
  excludeEmptyString: true,
  message: 'isValidSSN',
})

export const zipCodeValidator = yup
  .string()
  .trim()
  .matches(ZIP_CODE_PATTERN, { message: 'zipLengthErrorMessage' })
  .optional()
  .nullable(true)

export const isPinOk = (pin = '', pinLength = PIN_LENGTH) => {
  const isOnlyNumbers = /^\d+$/gi.test(String(pin))
  return (
    !!pin &&
    String(pin).length === pinLength &&
    isOnlyNumbers &&
    !SEQUENCE.includes(String(pin)) &&
    !INVERSE_SEQUENCE.includes(String(pin)) &&
    // @ts-ignore
    [...new Set(pin?.split(''))].length > 1
  )
}

export const isPasswordLong = (password = '', longerThan = 8) => {
  return String(password).length >= longerThan
}

export const isPasswordNumeric = (password = '') => {
  return /\d/g.test(String(password))
}

export const isPasswordUppercase = (password = '') => {
  return /([A-Z])/g.test(String(password))
}

export const isPasswordLowercase = (password = '') => {
  return /([a-z])/g.test(String(password))
}

export const isPasswordWithSpecialChar = (password = '') => {
  return /([!'_@#$%^&*(),.?":{}|<>+/\\;=`~[\]-])/gi.test(String(password))
}

export const isPasswordOk = (password?: string) => {
  return (
    isPasswordLong(password) &&
    isPasswordNumeric(password) &&
    isPasswordUppercase(password) &&
    isPasswordLowercase(password) &&
    isPasswordWithSpecialChar(password)
  )
}
